import { SVGProps } from "react";

export const SmallCrossPlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.5 7.5V5H7.5V7.5H5V8.5H7.5V11H8.5V8.5H11V7.5H8.5Z"
      fill="#706A85"
    />
  </svg>
);
